import React, { Fragment } from 'react';

import API from '../../../../utils/API';


import InputField from '../../../../components/inputs/inputField';
import FieldModal from '../../../../components/modals/fieldModal';
import { withRouter } from 'react-router-dom';

class DuplicateSessionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name ? this.props.name : '',
            submitting: false,
            requiredFields: { name: false }
        };
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    duplicateSession = async () => {
        this.setState({ submitting: true });
        const { name } = this.state;
        const { eventId, orgId, session } = this.props;
        const requiredFields = this.state.requiredFields;
        let valid = true;
        if (!name) {
            requiredFields.name = true;
            valid = false;
        }
        if (valid) {
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/duplicateSession/`, {
                    name: name,
                    duplicateId: session._id

                })
                .then((res) => {
                    if (res.data) {
                        this.props.addSession(res.data)
                        this.props.history.push(`/${orgId}/events/${eventId}/schedule/${res.data._id}`);
                        this.resetAdd(true);
                    }
                });
        } else {
            this.setState({ submitting: false, requiredFields: requiredFields });
        }
    };
    resetAdd = (e, toggle) => {
        this.setState({
            name: '',
        });
        if (!toggle === true) this.props.toggle();
    };

    render() {
        const { isOpen, toggle, sessionName } = this.props;
        const { submitting, name, requiredFields } = this.state;

        return (
            <div>

                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Duplicate Session"}
                    bodyHeaderText={`${sessionName}`}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Name"
                                    value={name}
                                    required={true}
                                    errorTrigger={requiredFields.name}
                                    onChange={this.handleNameChange}
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Duplicate' : 'Duplicating...'}
                    actionButton={() => this.duplicateSession()}
                    actionButtonDisabled={submitting}


                ></FieldModal>
            </div>

        );
    }
}

export default withRouter(DuplicateSessionModal);
